
import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import Plans from "./modules/plans/plan.component.vue";

import Company from "./modules/company/company.component.vue";
import Contact from "./modules/contact/contact.component.vue";
import Thanks from "./modules/thanks/thanks.component.vue";


const routes = [
  {
    path: '/', name: 'Plans', component: Plans  //, hash: "#"
  },
  {
    path: '/company', name: 'Company', component: Company //, hash: "#company"
  },
  {
    path: '/contact', name: 'Contact', component: Contact //, hash: "#contact"
  },
  {
    path: '/thanks', name: 'Thanks', component: Thanks //, hash: "#thanks"
  }
];


// const baseUrl = window.location.pathname;
const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
});
export default router;



// const routes = [
//   {
//     path: '/',
//     name: 'Price Plan Wizard',
//     children: [
//       {
//         path: '/', name: 'Plans', component: Plans  //, hash: "#"
//       },
//       {
//         path: 'company', name: 'Company', component: Company //, hash: "#company"
//       },
//       {
//         path: 'contact', name: 'Contact', component: Contact //, hash: "#contact"
//       },
//       {
//         path: 'thanks', name: 'Thanks', component: Thanks //, hash: "#thanks"
//       },
//     ]
//   },
// ];